import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql.cflowdev.com",
        "subdirectory": "/",
        "website": "",
        "subscriptionUrl": "",
        "assetDirectory": "/",
        "title": "cftest424242",
        "shortTitle": "cftest424242",
        "appKey": "3d5e247a-e5cc-4db8-b9f3-cd54b27ac74c",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "",
        "buildNumber": 849645,
        "buildDate": "2025-07-10T14:05:31.828Z",
        "version": "2.10.10"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "login",
            "host": "https://www.pw.org/paywall"
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "poets",
            "config": {
                "skipTOC": true,
                "feed": false
            }
        },
        "legal": {
            "privacy": {
                "url": "https://www.pw.org/privacy_policy",
                "label": "Privacy Policy"
            }
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        }
    }
};
export default config;